import https from "./https";

const shopline = {
  searchPhone(orgId, params) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }
    const searchParams = new URLSearchParams(params);

    return https.get(`/admin/organizations/${orgId}/shopline?${searchParams}`);
  },
};

export default shopline
